"use client";

import { useState } from "react";
import { useSearchParams } from "next/navigation";

export default function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const searchParams = useSearchParams();
  const externalError = searchParams.get("error");

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    if (res.ok) {
      window.location.href = "/";
      return;
    }

    const data = await res.json().catch(() => ({}));
    setError(data?.error ?? "Autentificare esuata.");
    setLoading(false);
  }

  return (
    <form onSubmit={onSubmit} className="form-grid">
      <label className="field">
        <span>Username</span>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="ex: adminsrs"
          autoComplete="username"
          required
        />
      </label>

      <label className="field">
        <span>Parola</span>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
      </label>

      {(error || externalError) && (
        <div className="notice notice-err">
          {error || externalError}
        </div>
      )}

      <button type="submit" className="btn btn-primary" disabled={loading}>
        {loading ? "Se autentifica..." : "Login"}
      </button>
    </form>
  );
}
